import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { filterBoolean } from '@core/common-legacy';
import type { VideoInterview } from '@core/integrations-http-legacy';

import { ZoomApiService } from './zoom-api';

export type ZoomHost = { email: string; kind: 'host' | 'alternative_host' };
export type ZoomUser = { email: string; name: string };

@Injectable({ providedIn: 'root' })
export class ZoomHttpClient {
  constructor(private zoomApi: ZoomApiService) {}

  public createZoomMeeting(params: {
    startsAt: string;
    timezone: string;
    duration: number;
    topic: string;
    admins: Array<{ email: string }>;
    admin: { email: string };
    host: string;
  }): Observable<VideoInterview> {
    return this.zoomApi
      .post('meeting', params)
      .pipe(map(({ meeting }: { meeting: VideoInterview }) => meeting));
  }

  public updateZoomMeeting(
    joinUrl: string,
    params: {
      startsAt: string;
      timezone: string;
      duration: number;
      topic: string;
      host: string;
    },
  ): Observable<VideoInterview> {
    return this.zoomApi
      .patch(`meeting?join_url=${encodeURI(joinUrl)}`, params)
      .pipe(map(({ meeting }: { meeting: VideoInterview }) => meeting));
  }

  public getZoomHosts({ joinUrl }: { joinUrl: string }): Observable<ZoomHost[]> {
    return this.zoomApi.get(`meeting-hosts?join_url=${encodeURI(joinUrl)}`).pipe(
      filterBoolean,
      map(({ hosts }: { hosts: ZoomHost[] }) => hosts),
    );
  }

  public getZoomUsers(): Observable<ZoomUser[]> {
    return this.zoomApi.get('users').pipe(
      filterBoolean,
      map(({ users }: { users: ZoomUser[] }) => users),
    );
  }

  public checkHostAvailability(params: {
    startsAt: string;
    timezone: string;
    duration: number;
    host: string;
    excludeJoinUrl: string | null;
  }): Observable<'available' | 'unavailable'> {
    return this.zoomApi.post('users/check-availability', params).pipe(map(({ status }) => status));
  }
}
